import * as React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { CancelButton } from "../../views/common-forms/components";
import * as enrollment from "../../shared/timeclock/actions/enrollment";
import { deviceCreateEnrollmentFile } from "../actions/device";
import { ConfirmationDialog } from "../components/ConfirmationDialog";
import { EnrollmentProps, ButtonTypes } from "../../shared/timeclock/models";
import { stampFingerprintRead } from "../actions";

interface EnrollmentState {
    displayInfoDialog: boolean;
}

function scansLeft(props: EnrollmentProps) {
    const { enrollmentToScan, deviceResults } = props;

    return enrollmentToScan - (deviceResults != null ? deviceResults.length : 0);
}

function mapStateToProps(state) {
    return {
        personRef: state.session.personRef,
        enrollmentMeta: state.session.enrollmentMeta,
        enrollmentToScan: state.session.enrollmentToScan,
        deviceResults: state.session.deviceResults
    };
}

const connector = connect(mapStateToProps);

class _Enrollment extends React.Component<EnrollmentProps, EnrollmentState> {
    constructor(props: EnrollmentProps) {
        super(props);
        this.state = {
            displayInfoDialog: false
        };
    }

    componentDidMount() {
        if (this.props.enrollmentMeta == "Rfid" || this.props.fakeFinger) {
            this.setState({ displayInfoDialog: false });
        } else {
            this.setState({ displayInfoDialog: true });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: EnrollmentProps) {
        if (nextProps.fakeFinger) {
            this.props.dispatch(stampFingerprintRead());
        } else if (scansLeft(nextProps) === 0) {
            const deviceId = nextProps.deviceResults[0].deviceId;
            const readerId = nextProps.deviceResults[0].readerId;
            const results = nextProps.deviceResults.map((dr) => dr.data);
            this.props.dispatch(deviceCreateEnrollmentFile(deviceId, readerId, nextProps.personRef, nextProps.enrollmentMeta, results));
        }
    }

    render() {
        const { enrollmentMeta, fakeFinger } = this.props;
        return (
            <div className="enrollment">
                {this.state.displayInfoDialog &&
                    <ConfirmationDialog message={<FormattedMessage id="ScanFingerInstruction" />} enableOkButton={true} confirmationClickedHandler={this.okClick} />
                }
                {!this.state.displayInfoDialog &&
                    <div>
                        <p className="tc-message-box">
                            <FormattedMessage id={fakeFinger ? "ScanFingerSimple" : "ScanFinger"}
                                values={{
                                    finger: <FormattedMessage id={`Fingers.${enrollmentMeta}`} />,
                                    times: scansLeft(this.props).toString()
                                }} />
                        </p>
                        <CancelButton onClick={this.cancel} />
                    </div>
                }

            </div>
        );
    }

    cancel = () => {
        this.props.dispatch(enrollment.cancel());
    };

    okClick = (value) => {
        if (value === ButtonTypes.Ok) {
            this.setState({ displayInfoDialog: false});
        }
    };
}

export const Enrollment = connector(_Enrollment);
